/* global grecaptcha */
'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;
	var errorSpan = '<span class="field-validation-error"><span>Please fill in the re-captcha.</span></span>';

	function expireCaptcha() {
		$('.g-recaptcha').parent().prepend(errorSpan);
	}

	function successfulCaptcha() {
		context.find('.field-validation-error').remove();
	}

	function verifyCaptcha() {
		context.find('.field-validation-error').remove();
		if ($('#g-recaptcha-response').val() === '') {
			$('.g-recaptcha').parent().prepend(errorSpan);
			return false;
		} else {
			return true;
		}
	}

	function init() {

		var captchaWrapper = context.find('.g-recaptcha')[0];

		$(window).on('load', function () {
			grecaptcha.render(captchaWrapper, {
				'sitekey': $(captchaWrapper).attr('data-sitekey'),
				'callback': successfulCaptcha,
				'expired-callback': expireCaptcha,
				'theme': $(captchaWrapper).attr('data-theme'),
				'type': $(captchaWrapper).attr('data-type'),
				'size': $(captchaWrapper).attr('data-size')
			});
		});

		context.parent().on('submit', function (e) {
			if (!verifyCaptcha()) {
				e.preventDefault();
				context.parent().find('[data-name="form-submit"]:last').prop('disabled', false);
			}
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/report-recaptcha.js
// module id = 494
// module chunks = 0